'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import hexToRgba from "hex-to-rgba";
import { Modal as RNModal, TouchableOpacity } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { gestureHandlerRootHOC } from "react-native-gesture-handler";
import { ScrollView } from "./ScrollView";
import { useTheme } from "../styles";
var ModalInner = gestureHandlerRootHOC(function(props) {
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsxs(TouchableOpacity, {
        testID: props.testID,
        accessible: false,
        activeOpacity: 1,
        style: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'stretch',
            backgroundColor: hexToRgba(theme.color.gray100, '0.5')
        },
        onPress: props.onRequestClose,
        children: [
            props.visible ? /*#__PURE__*/ _jsx(SystemBars, {
                style: "light"
            }) : null,
            /*#__PURE__*/ _jsx(ScrollView, {
                style: {
                    flex: 1
                },
                contentContainerStyle: {
                    flexGrow: 1,
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ _jsx(TouchableOpacity, {
                    accessible: false,
                    activeOpacity: 1,
                    style: props.style,
                    children: props.children
                })
            })
        ]
    });
});
/**
 * Standard wrapper around modal elements that help consistently layout content
 * across different modal designs.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-88}
 */ export function ModalContainer(props) {
    return /*#__PURE__*/ _jsx(RNModal, {
        visible: props.visible,
        transparent: true,
        onRequestClose: function() {},
        children: /*#__PURE__*/ _jsx(ModalInner, _object_spread({}, props))
    });
}
